import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs/Rx";
import {NeoStorageService} from 'ng-neo';

@Injectable()
export class UserService {

  public user: Subject<any>;

  public userInfo = {
    username: 'Guest'
  };

  constructor(private _store: NeoStorageService) {
    this.user = new Subject();
  }

  getLoginInfo():Observable<any> {

    return Observable.of(this._store.getNeoUser()).map((user) => {
        return {
            username: user.Username,
            picture: user.Gravatar || ""
        };
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.service.ts